import { notify } from "./bugsnag";
import { setPage } from "../stores/route";

export enum POSTypes {
  CVCore = "CVCore",
  NonCV = "NonCV",
}

export type ReceiptLocation = {
  locationNumber: number;
  franchiseNumber: string;
  storeNumber: string;
  addressLineOne: string;
  addressLineTwo: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  posTypeAsOfCampaignStart: {
    pos: string;
  };
}

const storeDataCountryToKey: Record<string, string> = {
  Canada: "CA",
  Mexico: "MX",
}

export const getReceiptLocations = async (country: string): Promise<ReceiptLocation[]> => {
  const domain = window.FoojiDevConfig?.FOOJI_DOMAIN || "prod.fooji.com";
  const response = await fetch(`https://images.${domain}/data/LittleCaesars/store_locations.json`)

  try {
    const staticStores = await response.json() as ReceiptLocation[];
    return staticStores.filter(store => storeDataCountryToKey[store.country] === country);
  } catch (error) {
    notify({ errorMessage: "Error fetching receipt locations", error });
    console.error("Error fetching receipt locations:", error);
    setPage("error");

    throw error;
  }
}
